// Tiny hand-placed pixel-art sprites, rendered as pure CSS box-shadow grids
// (no image files) so their color always matches the current PPG palette.
import React from 'react'
import styled from 'styled-components'

const HEART = [
  '01100110',
  '11111111',
  '11111111',
  '11111111',
  '01111110',
  '00111100',
  '00011000',
]

const STAR = [
  '00011000',
  '00011000',
  '11111111',
  '01111110',
  '01111110',
  '01100110',
  '11000011',
]

const SPARKLE = [
  '00100',
  '00100',
  '11111',
  '00100',
  '00100',
]

const SPRITES = { heart: HEART, star: STAR, sparkle: SPARKLE }

const Pixel = styled.span`
  display: inline-block;
  position: relative;
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  background: transparent;
  box-shadow: ${(props) => props.$shadow};
`

const buildShadow = (grid, size, color) => {
  const shadows = []
  grid.forEach((row, y) => {
    row.split('').forEach((cell, x) => {
      if (cell === '1') {
        shadows.push(`${x * size}px ${y * size}px 0 0 ${color}`)
      }
    })
  })
  return shadows.join(', ') || 'none'
}

// name: 'heart' | 'star' | 'sparkle'
const PixelSprite = ({ name, size = 4, color = '#FF3E8E', style, className }) => {
  const grid = SPRITES[name] || SPARKLE
  return (
    <Pixel
      $size={size}
      $shadow={buildShadow(grid, size, color)}
      style={style}
      className={className}
    />
  )
}

export default PixelSprite
